module.exports = __webpack_public_path__ + "img/luggagePhoto.53ca4825.png";